export default __webpack_public_path__ + "static/media/ava-5.44843bd1.png";